<template>
	<div
		class="summary__contents"
		:class="`is-sectionTitle-${sectionTitleStyle}`"
	>
		<div class="summary__section" v-if="isAxialLoadUsed">
			<p class="summary__sectionTitle">{{ $t("Esforço Axial") }}</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Tipo de carga") }}</div>
					<div class="summary__itemValue">
						{{ getOption("axialLoadTypes", values.axialLoads.type).label }}
					</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Carga") }}</div>
					<div class="summary__itemValue">
						{{ values.axialLoads.value }}
					</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Tracção/Compressão") }}</div>
					<div class="summary__itemValue">
						{{ getOption("direction", values.axialLoads.direction).label }}
					</div>
				</div>
			</div>
		</div>

		<div
			class="summary__section"
			v-if="
				values.locks.use &&
					values.locks.upperFibre.type !== 0 &&
					values.locks.lowerFibre.use
			"
		>
			<p class="summary__sectionTitle">{{ $t("Travamentos") }}</p>

			<div class="summary__grid">
				<div class="summary__item" v-if="values.locks.upperFibre.type !== 0">
					<div class="summary__itemLabel">{{ $t("Fibra superior") }}</div>
					<div class="summary__itemValue" v-html="upperFibreContent"></div>
				</div>

				<div class="summary__item" v-if="values.locks.lowerFibre.use">
					<div class="summary__itemLabel">{{ $t("Fibra inferior") }}</div>
					<div class="summary__itemValue" v-html="lowerFibreContent"></div>
				</div>
			</div>
		</div>

		<div class="summary__section" v-if="values.claddingProperties.use">
			<p class="summary__sectionTitle">
				{{ $t("Contribuição de chapa de revestimento") }}
			</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Número de fixações") }}</div>
					<div class="summary__itemValue">
						{{ values.claddingProperties.coveringInertia }}
					</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">
						{{ $t("Inércia de Chapa de Revestimento") }} (m⁴/m)
					</div>
					<div class="summary__itemValue">
						{{ values.claddingProperties.fixationsPerMeter }}
					</div>
				</div>
			</div>
		</div>

		<div class="summary__section">
			<p class="summary__sectionTitle">
				{{ $t("Deformação & Combinação") }}
			</p>

			<div class="summary__grid">
				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Deformação") }}</div>
					<div class="summary__itemValue">{{ values.deformation }}</div>
				</div>

				<div class="summary__item">
					<div class="summary__itemLabel">{{ $t("Combinação") }}</div>
					<div class="summary__itemValue">
						{{ getOption("combination", values.combination).label }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import emitLifecycleEvents from "@/mixins/emitLifecycleEvents";

// axial loads are not part of the calculation at the moment
const isAxialLoadUsed = false;

export default {
	mixins: [emitLifecycleEvents],
	props: {
		values: {
			type: Object,
			required: true,
		},
		sectionTitleStyle: {
			type: String,
			default: "block",
		},
	},
	data() {
		return {
			isAxialLoadUsed,
		};
	},
	computed: {
		...mapState("simulator", ["simulationOptions"]),
		...mapGetters("simulator", [
			"getOption",
			"spanDescriptions",
			"getMainSpanDescriptions",
			"consoleSpanDescriptions",
		]),

		upperFibreContent() {
			return this.getLoadSummaryContent(this.values.locks.upperFibre);
		},
		lowerFibreContent() {
			return this.getLoadSummaryContent(this.values.locks.lowerFibre);
		},
	},

	methods: {
		getLoadSummaryContent(load) {
			const { main, console, cfgMode } = load;
			let items;

			if (!cfgMode.isSpanBySpan) {
				items = [`${main[0]} kN/m2`];
			} else {
				items = [
					...console.map((val, idx) => {
						const label = this.consoleSpanDescriptions[idx].label;
						return `${label}: ${val} kN/m2`;
					}),
					...main.map((val, idx) => {
						const label = this.getMainSpanDescriptions(this.values.spans)[idx]
							.label;
						return `${label}: ${val} kN/m2`;
					}),
				];
			}
			return items.map((item) => `<p>${item}</p>`).join("");
		},
	},
};
</script>

<style lang="scss"></style>
